module.exports = {"id":"193062","name":"Marvin Zeegelaar","rating":"75","photo":"./data/images/photos/1/193062.png","club":{"name":"Watford","logo":"./data/images/clubs/Watford.png"},"positions":["DG","DLG"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/MarvinZeegelaar0.json
// module id = 2837
// module chunks = 0